/** @jsxImportSource @emotion/react */
import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface MapMarkerIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number
  color?: string
}

const MapMarkerIcon: React.FC<MapMarkerIconProps> = ({
  size = 16,
  color = colors.NEUTRAL_50,
  className,
  style,
  ...rest
}) => {
  return (
    <span className={`anticon ${className || ''}`} style={style} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M8.00002 7.99992C8.36669 7.99992 8.68069 7.86925 8.94202 7.60792C9.20291 7.34703 9.33335 7.03325 9.33335 6.66658C9.33335 6.29992 9.20291 5.98592 8.94202 5.72459C8.68069 5.4637 8.36669 5.33325 8.00002 5.33325C7.63335 5.33325 7.31958 5.4637 7.05869 5.72459C6.79735 5.98592 6.66669 6.29992 6.66669 6.66658C6.66669 7.03325 6.79735 7.34703 7.05869 7.60792C7.31958 7.86925 7.63335 7.99992 8.00002 7.99992ZM8.00002 12.8999C9.35558 11.6555 10.3611 10.5248 11.0167 9.50792C11.6722 8.49147 12 7.58881 12 6.79992C12 5.58881 11.6138 4.59703 10.8414 3.82459C10.0694 3.05259 9.12224 2.66659 8.00002 2.66659C6.8778 2.66659 5.93046 3.05259 5.15802 3.82459C4.38602 4.59703 4.00002 5.58881 4.00002 6.79992C4.00002 7.58881 4.3278 8.49147 4.98335 9.50792C5.63891 10.5248 6.64446 11.6555 8.00002 12.8999ZM8.00002 14.4166C7.91113 14.4166 7.82224 14.3999 7.73335 14.3666C7.64446 14.3333 7.56669 14.2888 7.50002 14.2333C5.8778 12.7999 4.66669 11.4695 3.86669 10.2419C3.06669 9.01392 2.66669 7.86658 2.66669 6.79992C2.66669 5.13325 3.20291 3.80547 4.27535 2.81659C5.34735 1.8277 6.58891 1.33325 8.00002 1.33325C9.41113 1.33325 10.6527 1.8277 11.7247 2.81659C12.7971 3.80547 13.3334 5.13325 13.3334 6.79992C13.3334 7.86658 12.9334 9.01392 12.1334 10.2419C11.3334 11.4695 10.1222 12.7999 8.50002 14.2333C8.43335 14.2888 8.35558 14.3333 8.26669 14.3666C8.1778 14.3999 8.08891 14.4166 8.00002 14.4166Z'
          fill={color}
        />
      </svg>
    </span>
  )
}

export default MapMarkerIcon
